import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';

// Провайдер авторизации
import { AuthProvider } from './context/AuthContext';

// Компоненты
import ProtectedRoute from './components/ProtectedRoute';
import AppLayout from './components/AppLayout';

// Страницы
import LoginPage from './pages/LoginPage';
import ChatsPage from './pages/ChatsPage';
import ChatDetailsPage from './pages/ChatDetailsPage';
import ModuleSettingsPage from './pages/ModuleSettingsPage';

// Создание темы
const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
    },
    secondary: {
      main: '#f50057',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            {/* Публичные маршруты */}
            <Route path="/login" element={<LoginPage />} />
            
            {/* Защищенные маршруты */}
            <Route element={<ProtectedRoute />}>
              <Route element={<AppLayout />}>
                <Route path="/" element={<Navigate to="/chats" replace />} />
                <Route path="/chats" element={<ChatsPage />} />
                <Route path="/chats/:chatId" element={<ChatDetailsPage />} />
                <Route path="/chats/:chatId/modules/:moduleName" element={<ModuleSettingsPage />} />
              </Route>
            </Route>
            
            {/* Перенаправление на страницу входа для всех остальных маршрутов */}
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App; 